<template>
  <div class="login-page-sanbianchi">
    <div class="login-page-overlay">
      <div class="login-container">
        <div class="login-brand">
          <img
            src="media/logos/logo_nuts_1.png"
            alt="Sanbianchi Tecnologia"
            class="login-brand-image"
          />
        </div>

        <div
          class="login-card"
          :class="{ 'login-card--wide': state !== 'signin' }"
        >
          <!-- SIGN IN -->
          <div v-show="state === 'signin'" class="login-form login-signin">
            <form
              class="form"
              novalidate="novalidate"
              id="kt_login_signin_form"
              @submit.stop.prevent="onSubmitLogin()"
            >
              <div class="login-header">
                <h3 class="login-title">Bem vindo</h3>
                <p class="login-subtitle">
                  Não possui conta?
                  <a
                    id="kt_login_signup"
                    class="login-link"
                    @click="showForm('signup')"
                  >
                    Cadastre-se
                  </a>
                </p>
              </div>

              <b-form-group class="login-group" label="" label-for="login-email">
                <label class="login-label">E-mail</label>
                <b-form-input
                  id="login-email"
                  name="email"
                  ref="email"
                  v-model="$v.form.email.$model"
                  :state="validateState('email')"
                  class="login-input"
                ></b-form-input>
                <b-form-invalid-feedback>
                  E-mail inválido.
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                class="login-group"
                label=""
                label-for="login-password"
              >
                <label class="login-label">Senha</label>
                <b-form-input
                  type="password"
                  id="login-password"
                  name="password"
                  v-model="$v.form.password.$model"
                  :state="validateState('password')"
                  class="login-input"
                ></b-form-input>
                <b-form-invalid-feedback>
                  Campo senha é obrigatório.
                </b-form-invalid-feedback>
              </b-form-group>

              <div class="forgot-row">
                <a
                  class="forgot-link"
                  id="kt_login_forgot"
                  @click="showForm('forgot')"
                >
                  Esqueceu a senha?
                </a>
              </div>

              <div class="login-actions">
                <button
                  ref="kt_login_submit"
                  class="btn-login-primary"
                  type="submit"
                >
                  Entrar
                </button>
              </div>
            </form>
          </div>

          <!-- SIGN UP -->
          <div v-show="state === 'signup'" class="login-form login-signup">
            <form
              class="form"
              novalidate="novalidate"
              id="kt_login_signup_form"
              @submit.stop.prevent="onSubmitConta()"
            >
              <div class="login-header">
                <h3 class="login-title">Cadastre-se</h3>
                <p class="login-subtitle">
                  Informe os dados para criar sua conta
                </p>
              </div>

              <b-form-group class="login-group">
                <label class="login-label">Nome</label>
                <b-form-input
                  id="conta-nome"
                  name="nome"
                  autocomplete="off"
                  v-model="$v.conta.nome.$model"
                  :state="validadeStateConta('nome')"
                  class="login-input"
                ></b-form-input>
                <b-form-invalid-feedback>
                  Campo obrigatório.
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group class="login-group">
                <label class="login-label">E-mail</label>
                <b-form-input
                  id="conta-email"
                  name="conta-email"
                  autocomplete="off"
                  v-model="$v.conta.email.$model"
                  :state="validadeStateConta('email')"
                  class="login-input"
                ></b-form-input>
                <b-form-invalid-feedback>
                  Campo obrigatório.
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group class="login-group">
                <label class="login-label">Telefone</label>
                <b-form-input
                  id="conta-fone"
                  name="conta-fone"
                  autocomplete="off"
                  v-model="$v.conta.fone.$model"
                  :state="validadeStateConta('fone')"
                  v-mask="['(##) #### ####', '(##) # #### ####']"
                  class="login-input"
                ></b-form-input>
                <b-form-invalid-feedback>
                  Campo obrigatório.
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group class="login-group">
                <label class="login-label">Empresa</label>
                <b-form-input
                  id="conta-nome_empresa"
                  name="nome_empresa"
                  autocomplete="off"
                  v-model="$v.conta.nome_empresa.$model"
                  :state="validadeStateConta('nome_empresa')"
                  class="login-input"
                ></b-form-input>
                <b-form-invalid-feedback>
                  Campo obrigatório.
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group class="login-group">
                <label class="login-label">Senha</label>
                <b-form-input
                  type="password"
                  id="conta-senha"
                  name="conta-senha"
                  autocomplete="off"
                  v-model="$v.conta.password.$model"
                  :state="validadeStateConta('password')"
                  class="login-input"
                ></b-form-input>
                <b-form-invalid-feedback>
                  Campo obrigatório.
                </b-form-invalid-feedback>
              </b-form-group>

              <div class="terms-box">
                <label class="checkbox mb-0">
                  <input type="checkbox" v-model="conta.termos" />
                  <span class="mr-2"></span>
                  Aceito com os
                  <a href="#/termos" target="_blank" class="ml-2 login-link">
                    termos e condições
                  </a>
                </label>
              </div>

              <div class="actions-stack">
                <button
                  ref="kt_login_submit_conta"
                  class="btn-login-primary"
                  type="submit"
                >
                  Salvar
                </button>

                <button
                  type="button"
                  id="kt_login_signup_cancel"
                  class="btn-login-secondary"
                  @click="showForm('signin')"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>

          <!-- FORGOT -->
          <div v-show="state === 'forgot'" class="login-form login-forgot">
            <form
              class="form"
              novalidate="novalidate"
              id="kt_login_forgot_form"
              @submit.stop.prevent="onSubmitResetConta()"
            >
              <div class="login-header">
                <h3 class="login-title">Esqueceu a senha?</h3>
                <p class="login-subtitle">
                  Insira seu e-mail para redefinir sua senha
                </p>
              </div>

              <b-form-group class="login-group">
                <label class="login-label">E-mail</label>
                <b-form-input
                  id="email"
                  name="email"
                  ref="email"
                  v-model="$v.reset.email.$model"
                  :state="validadeStateReset('email')"
                  class="login-input"
                ></b-form-input>
                <b-form-invalid-feedback>
                  Campo obrigatório.
                </b-form-invalid-feedback>
              </b-form-group>

              <div class="actions-stack">
                <button
                  ref="kt_login_forgot_submit"
                  class="btn-login-primary"
                  type="submit"
                >
                  Enviar
                </button>

                <button
                  type="button"
                  id="kt_login_forgot_cancel"
                  class="btn-login-secondary"
                  @click="showForm('signin')"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LOGIN, REGISTER } from "@/core/services/store/auth.module";
import KTUtil from "@/assets/js/components/util";
import { mapGetters, mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { email, minLength, required } from "vuelidate/lib/validators";
import { httpResetLogin } from "../../../configurations/axios";
import { mask } from "vue-the-mask";

export default {
  mixins: [validationMixin],
  name: "login",
  data() {
    return {
      state: "signin",
      form: {
        email: "",
        password: "",
      },
      conta: {
        nome: "",
        nome_empresa: "",
        email: "",
        password: "",
        fone: "",
        termos: false,
      },
      reset: {
        email: "",
      },
    };
  },
  directives: {
    mask,
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
      password: {
        required,
        minLength: minLength(3),
      },
    },
    conta: {
      nome: {
        required,
      },
      nome_empresa: {
        required,
      },
      email: {
        required,
        email,
      },
      fone: {
        required,
      },
      password: {
        required,
        minLength: minLength(4),
      },
    },
    reset: {
      email: {
        required,
        email,
      },
    },
  },
  methods: {
    showForm(form) {
      this.state = form;
      const form_name = "kt_login_" + form + "_form";

      this.$nextTick(() => {
        const el = KTUtil.getById(form_name);
        if (el) {
          KTUtil.animateClass(el, "animate__animated animate__fadeIn");
        }
      });
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    validadeStateConta(name) {
      const { $dirty, $error } = this.$v.conta[name];
      return $dirty ? !$error : null;
    },
    validadeStateReset(name) {
      const { $dirty, $error } = this.$v.reset[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        email: null,
        password: null,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    async onSubmitLogin() {
      const submitButton = this.$refs["kt_login_submit"];

      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          return;
        }

        const email = this.$v.form.email.$model;
        const password = this.$v.form.password.$model;

        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        submitButton.setAttribute("disabled", "");

        await this.$store.dispatch(LOGIN, { email, password });
        this.$toast.success("Logado com sucesso!");
        this.$router.push({ name: "dashboard" });
      } catch (error) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        submitButton.removeAttribute("disabled", "");
      }
    },
    async onSubmitConta() {
      const submitButton = this.$refs["kt_login_submit_conta"];

      try {
        this.$v.conta.$touch();

        if (this.$v.conta.$anyError) {
          return;
        }

        if (!this.conta.termos) {
          this.$toast.warning("Verifique os termos de uso!");
          return;
        }

        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        await this.$store.dispatch(REGISTER, this.conta);
        this.$router.push({ name: "dashboard" });
      } catch (error) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
      }
    },
    async onSubmitResetConta() {
      const submitButton = this.$refs["kt_login_forgot_submit"];

      try {
        this.$v.reset.$touch();

        if (this.$v.reset.$anyError) {
          return;
        }

        const email = this.$v.reset.email.$model;
        submitButton.classList.add("spinner", "spinner-light", "spinner-right");

        await httpResetLogin.post("usuario/reset-password", {
          email,
        });

        this.$toast.success("Verifique no seu e-mail e siga o procedimento!");
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
      } catch (error) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
      }
    },
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
    ...mapGetters(["currentUser"]),
  },
  mounted() {
    KTUtil.getById("kt_login_signin_form");
    KTUtil.getById("kt_login_signup_form");
    KTUtil.getById("kt_login_forgot_form");
  },
};
</script>

<style lang="scss" scoped>
.login-page-sanbianchi {
  min-height: 100vh;
  width: 100%;
  background-image: url("/media/bg/bg-login-sanbianchi.jpg");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  position: relative;
}

.login-page-overlay {
  min-height: 100vh;
  width: 100%;
  background: rgba(245, 248, 252, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
}

.login-container {
  width: 100%;
  max-width: 1100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.login-brand {
  margin-bottom: 34px;
  text-align: center;
}

.login-brand-image {
  width: 100%;
  max-width: 300px;
  height: auto;
  display: block;
}

.login-card {
  width: 100%;
  max-width: 340px;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(24, 42, 73, 0.16);
  padding: 26px 28px 28px;
  backdrop-filter: blur(2px);
}

.login-card--wide {
  max-width: 420px;
}

.login-header {
  text-align: center;
  margin-bottom: 18px;
}

.login-title {
  margin: 0 0 4px;
  font-size: 24px;
  line-height: 1.2;
  font-weight: 600;
  color: #121212;
}

.login-subtitle {
  margin: 0;
  font-size: 14px;
  color: #3e4b5a;
}

.login-link {
  color: #1c6db5;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
}

.login-link:hover {
  color: #0f5aa8;
  text-decoration: none;
}

.login-group {
  margin-bottom: 14px;
}

.login-label {
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #1b1b1b;
}

.login-input {
  height: 38px !important;
  min-height: 38px !important;
  border-radius: 7px !important;
  border: 1px solid #c8d1dd !important;
  background: #edf2fb !important;
  color: #1b1b1b !important;
  padding: 8px 12px !important;
  font-size: 14px !important;
  box-shadow: none !important;
}

.login-input:focus {
  border-color: #2d73c7 !important;
  background: #f4f8ff !important;
  box-shadow: 0 0 0 0.12rem rgba(45, 115, 199, 0.14) !important;
}

.forgot-row {
  display: flex;
  justify-content: flex-end;
  margin-top: -2px;
  margin-bottom: 14px;
}

.forgot-link {
  font-size: 13px;
  font-weight: 500;
  color: #1c6db5;
  text-decoration: none;
  cursor: pointer;
}

.forgot-link:hover {
  color: #0f5aa8;
  text-decoration: none;
}

.login-actions {
  margin-top: 2px;
}

.btn-login-primary {
  width: 100%;
  height: 38px;
  border: 0;
  border-radius: 7px;
  background: linear-gradient(90deg, #005fd0 0%, #0563d8 100%);
  color: #ffffff;
  font-size: 15px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.btn-login-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(0, 95, 208, 0.2);
}

.btn-login-secondary {
  width: 100%;
  height: 38px;
  border: 1px solid #d5dce7;
  border-radius: 7px;
  background: #ffffff;
  color: #415168;
  font-size: 15px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.btn-login-secondary:hover {
  background: #f7f9fc;
}

.actions-stack {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.terms-box {
  margin: 6px 0 16px;
  font-size: 13px;
  color: #48576a;
}

.spinner.spinner-right {
  padding-right: 3.5rem !important;
}

@media (max-width: 768px) {
  .login-page-overlay {
    padding: 20px 12px;
  }

  .login-brand {
    margin-bottom: 24px;
  }

  .login-brand-image {
    max-width: 260px;
  }

  .login-card,
  .login-card--wide {
    max-width: 100%;
    padding: 22px 18px 22px;
  }
}
</style>